import { connect } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getShopItemsStreamId } from '../../../../../streams/shop';
import { ShopItemType } from '../../../../../../types/shop';
import { changeCommissionsGlobalStatus } from '../../../../../actions/commissions';

export default connect(
  (state: AppState) => {
    const streamId = getShopItemsStreamId(ShopItemType.COMMISSIONS);

    return {
      total: streamSelectors.getTotal(state, streamId),
    };
  },
  dispatch => {
    return {
      enableAllCommissions: () =>
        dispatch(changeCommissionsGlobalStatus({ isOpen: true })),
    };
  }
);
